<template>
  <div class="my-token">
    <div class="title">钱包余额</div>
    <div class="table-header">
      <span>资产</span>
      <span>余额</span>
    </div>
    <div class="detail" v-for="(token, index) in myTokenListsDetail" :key="index">
      <span>{{token.name}}</span>
      <span :style="{ color: index === 0 ? '#b542f7' : '#00a577'}">{{token.balances}}</span>
    </div>
    <template v-if="myAddress">
      <div class="global-status">
        <span>总分红金额(USDT)</span>
        <span>{{ accountStatus.totalOut }}</span>
      </div>
      <div class="global-status">
        <span>质押代币总数(HST)</span>
        <span>{{ accountStatus.totalStake }}</span>
      </div>
      <br />  
      <div class="global-status">
        <span>你已领取的分红(USDT)</span>
        <span>{{ accountStatus.withdrawDivide }}</span>
      </div>
      <div class="global-status">
        <span>你已质押的代币(HST)</span>
        <span>{{ accountStatus.stakedToken }}</span>
      </div>
      <div style="margin-left: 6px" v-if="!registerName">
        <div class="register-input"><span>您的名字:</span><input class="hst-input" v-model="userInputName" placeholder="eg:buytoken"/></div>
        <button @click="register">生成您的专属邀请链接!</button>
      </div>
      <button  class="hst-clipboard" v-else>您的专属链接地址:{{url}}
        <svg 
          @click="doCopy"
          t="1577684360755" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1289" width="14" height="14" data-spm-anchor-id="a313x.7781069.0.i10"><path d="M322 321l384 0c-3.376-40-19.458-70.9-55.842-80.712-0.892-0.238-2.24-0.848-3.134-1.082-24.008-6.848-42.024-15.306-42.024-41.562L605 156.454C605 105.382 563.952 64 512.98 64c-50.932 0-91.98 41.382-91.98 92.454l0 41.19c0 26.256-17.184 34.338-41.194 41.186-0.894 0.234-1.6 1.22-2.532 1.458C340.892 250.1 325.854 281 322 321zM513.98 128.79c15.23 0 27.582 12.39 27.582 27.664 0 15.308-12.352 27.7-27.582 27.7-15.228 0-27.544-12.39-27.544-27.7C486.436 141.18 498.752 128.79 513.98 128.79z" p-id="1290" fill="#454349"></path><path d="M811.222 127 663 127l0 27.976c0 21.166 18.386 38.024 39.014 38.024l74.424 0c13.334 0 24.198 10.87 24.88 24.39l0.17 654.2c-0.644 12.864-10.606 23.092-23.028 24.034l-528.836 0.062c-12.422-0.942-22.298-11.39-22.944-24.252l-0.17-654.028c0.644-13.522 11.716-24.406 25.012-24.406l74.462 0c20.626 0 37.014-16.858 37.014-38.024L362.998 127l-146.262 0C186.5 127 161 152.116 161 183.15l0 720.76c0 31.004 25.5 57.09 55.738 57.09L513.98 961l297.242 0c30.276 0 53.778-26.086 53.778-57.09L865 183.15C865 152.116 841.498 127 811.222 127z" p-id="1291" fill="#454349"></path><path d="M289 385l224 0 0 64-224 0 0-64Z" p-id="1292" fill="#454349"></path><path d="M289 769l320 0 0 64-320 0 0-64Z" p-id="1293" fill="#454349"></path><path d="M289 641l258 0 0 64-258 0 0-64Z" p-id="1294" fill="#454349"></path><path d="M289 513l416 0 0 64-416 0 0-64Z" p-id="1295" fill="#454349"></path></svg>
      </button>
    </template>
  </div>
</template>

<script>
import { loadWeb3, toFix6, confirmingTransaction } from '../util.js'
import Web3 from 'web3'
import { mapState } from 'vuex'

export default {
  name: 'Wallet',
  data() {
    return {
      // 所有的代币情况
      myTokenListsDetail: [{name: 'USDT', balances: '- - -'}, {name: 'HST', balances: '- - -'}],
      userInputName: '',
    }
  },
  computed: {
    ...mapState({
      usdtContract: state => state.usdtContract,
      hstContract: state => state.hstContract,
      myAddress: state => state.myAddress,
      hstAddress: state => state.hstAddress,
      registerName: state => state.registerName,
      referNameByte32: state => state.referNameByte32,
      accountStatus: state => state.accountStatus,
    }),
    url() {
      return window.location.origin + window.location.pathname + '?refer=' + this.registerName;
    }
  },
  methods: {
    register() {
      const option = {
        group: 'notify'
      };
      if(!this.userInputName) {
        option.type = 'error',
        option.text = '请填写您的邀请名字',
        this.$notify(option);
        return;
      }
      const inputNameHex = web3.utils.fromAscii(this.userInputName).padEnd(66, '0');
      this.hstContract.methods.registere(inputNameHex).send()
        .on('transactionHash', hash => {
          confirmingTransaction(this, hash);
        })
        .then( res => {
          option.type = 'success',
          option.text = '您的个人专属邀请地址生成成功!',
          this.$notify(option);
          this.$store.commit('unshiftTrxData', {
            id: res.transactionHash,
            status: 'ok'
          });
          this.$store.commit('setRegisterName', this.userInputName);
        })
        .catch(err => {
          option.type = 'error',
          option.text = '您的个人专属邀请地址生成失败!请稍后再试!',
          this.$notify(option);
        });
    },
    doCopy() {
      const option = {
        group: 'notify'
      };
      const input = document.createElement('input');
      input.setAttribute('readonly', 'readonly');
      input.setAttribute('value', this.url);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        option.type = 'success';
        option.text = '您的专属链接: '+ this.url +'复制成功'  +',快去分享吧!'
      } else {
        option.type = 'error';
        option.text = '您的浏览器太OUT了,快试试手动选中复制吧!'
      }
      document.body.removeChild(input);
      this.$notify(option);
    },
    // 钱包 USDT 和 HST 余额
    refreshBalance() {
      this.usdtContract.methods.balanceOf(this.myAddress).call()
        .then(res => {
          this.$set(this.myTokenListsDetail, 0,{
            name: 'USDT',
            balances: toFix6(res)
          })
          this.$store.commit('setAccountStatus', {
            usdt: toFix6(res)
          });
        });
      this.hstContract.methods.balanceOf(this.myAddress).call()
        .then(res => {
          this.$set(this.myTokenListsDetail, 1,{
            name: 'HST',
            balances: toFix6(res)
          })
          this.$store.commit('setAccountStatus', {
            hst: toFix6(res)
          });
        });
    },
    async checkAllowed() {
      // 账号 hst
      return this.usdtContract.methods.allowed(this.myAddress, this.hstAddress).call()
    },

    approveSendUsdt() {
      // hst 21000000000000
      this.usdtContract.methods.approve(this.hstAddress, 21000000000000).send()
        .on('confirmation', (confirmationNumber, receipt) => {
          this.$modal.hide('approve-hst');
        })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media (max-width: 600px){
  .my-token {
    position: relative !important;
  }
}
.my-token {
  position: fixed;
  right: 12px;
  top: 12px;
  width: 288px;
  padding: 12px;
  margin: 12px;
  border: 1px rgb(212, 217, 225) solid;
  background-color: white;
  border-radius: 4px;
  .global-status {
    display: flex;
    justify-content: space-between;
    margin-left: 6px;
    margin-top: 12px;
  }
  .register-input {
    margin-top: 12px;
    margin-bottom: 12px;
    letter-spacing: 0.3px;
    color: #222222;
    font-size: 1rem;
    span:first-child {
      display: inline-block;
      padding-bottom: 6px;
    }
  }
  .hst-input {
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: rgb(34, 34, 34);
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
  }
  .title {
    font-size: 1.4rem;
    line-height: 1;
    font-weight: 500;
    color: rgb(35, 21, 54);
    margin: 6px;
    padding-bottom: 4px;
  }
  .table-header, .detail {
    display: flex;
    margin: 6px;
    span {
      width: 50%;
      font-size: 1.1rem;
      text-transform: uppercase;
      letter-spacing: 0.3px;
      line-height: 22px;
      color: rgb(112, 131, 144);
      font-weight: 700;
    }
  }
  .table-header span {
    font-size: 0.8rem;
  }
  .detail span {
    color: rgb(72, 73, 95);
  }
  button {
    margin-top: 8px;
    display: block;
  }
  .hst-clipboard {
    font-size: 1rem;
    padding: 0;
    vertical-align: middle;
    background-color: transparent;
    border: 0px;
    letter-spacing: 0.3px;
    color: rgb(34, 34, 34);;
    white-space: normal;
    word-wrap: break-word;
    word-break: break-all;
    user-select: text;
    text-align: start;
    margin-left: 6px;
    margin-top: 12px;
    cursor: text;
    .icon {
      cursor: pointer;
      width: 24px;
      height: 24px;
      padding: 0;
      margin: 0;
      vertical-align: middle;
    }
  }
}
</style>
